var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoSearch = function SvgIcoSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 9.29c0 5.127 4.087 9.29 9.117 9.29 1.96 0 3.75-.619 5.235-1.685l5.537 5.643c.236.24.574.379.878.379s.641-.137.879-.38a1.307 1.307 0 0 0 0-1.788l-5.47-5.574a9.4 9.4 0 0 0 2.06-5.885C18.236 4.164 14.15 0 9.12 0S0 4.164 0 9.29m1.993 0c0-3.992 3.208-7.26 7.126-7.26 3.916.001 7.124 3.235 7.124 7.26s-3.208 7.261-7.125 7.261-7.125-3.268-7.125-7.26"
  })));
};
export default SvgIcoSearch;